import { Dispatch, SetStateAction, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useAppDispatch } from 'app/hooks';

import { useAPICall } from 'hooks/useAPICall';
import { getTraceHistory } from 'api/snapshotApi';

import { TraceHistoryFilters } from '../types';
import { UseFormSetValue } from 'react-hook-form';
import { utcToZonedTime } from 'date-fns-tz';
import { useUserDateTime } from '../../timezone/hooks/useUserDateTime';

interface Props {
  hasQueryString: boolean;
  snapshotIdToLoad: number;
  analyzerIdToLoad: number;
  setLocalTraceIndex: Dispatch<SetStateAction<{ 1: number; 2: number }>>;
  setGlobalTraceIndex: Dispatch<SetStateAction<number>>;
  traceIndex: number;
  startTime: string | null;
  endTime: string | null;
  setValue: UseFormSetValue<TraceHistoryFilters>;
  handleSubmit: any;
}

const useLoadHistoryLink = ({
  hasQueryString,
  snapshotIdToLoad,
  analyzerIdToLoad,
  setLocalTraceIndex,
  setGlobalTraceIndex,
  traceIndex,
  startTime,
  endTime,
  setValue,
  handleSubmit,
}: Props) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { timezone } = useUserDateTime();

  const { safeCall: safeGetTraceHistory } = useAPICall(getTraceHistory);

  // When the query parameters change, update the page's form fields per the parameters
  useEffect(() => {
    if (!hasQueryString) return;
    const initializePage = async () => {
      if (
        !snapshotIdToLoad ||
        snapshotIdToLoad === -1 ||
        !analyzerIdToLoad ||
        analyzerIdToLoad === -1 ||
        !endTime ||
        !startTime
      )
        return;
      setValue('fromDate', utcToZonedTime(startTime, timezone));
      setValue('toDate', utcToZonedTime(endTime, timezone));
      setValue('analyzerId', analyzerIdToLoad);
      setValue('snapshotId', snapshotIdToLoad);
      setValue('savedAnalyzerId', analyzerIdToLoad);
      setValue('savedSnapshotId', snapshotIdToLoad);

      await handleSubmit();
      setLocalTraceIndex((state: any) => ({ ...state, 1: traceIndex }));
      setGlobalTraceIndex(traceIndex);
    };
    initializePage();
    //eslint-disable-next-line
  }, [
    analyzerIdToLoad,
    snapshotIdToLoad,
    startTime,
    endTime,
    hasQueryString,
    dispatch,
    traceIndex,
    navigate,
    safeGetTraceHistory,
  ]);
};

export default useLoadHistoryLink;
